
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/book",
      function () {
        return require("private-next-pages/book.js");
      }
    ]);
  